import { Typography, useTheme } from '@mui/material';
import { Button } from '@rcg/ui-components';
import styled, { keyframes } from 'styled-components';
import colors from 'styles/colors';
import fonts from 'styles/fonts';
import media from 'styles/media';
import sizes from 'styles/sizes';
import { BrandCode } from 'types/Brand';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const FilterBackground = styled.div`
	background-color: ${colors.functional.black};
	height: 100%;
	left: 0;
	opacity: 0.7;
	position: fixed;
	top: 0;
	width: 100%;
	z-index: 10;
`;

export const ModalWrapper = styled.section`
	animation: ${fadeIn} 0.25s forwards;
	background-color: transparent;
	border-radius: 5px 5px 0 0;
	bottom: 0;
	flex-direction: column;
	justify-content: flex-start;
	left: 0;
	overflow: hidden;
	padding: 0;
	position: fixed;
	right: 0;
	top: 0;
	z-index: 15;
	pointer-events: none;

	@media (min-width: ${sizes.media.mediumMaxWidth}px) {
		top: 12%;
		margin: 0 auto;
		/* margin: auto; */
		width: min(1150px, 95vw);
		@media (max-height: 850px) {
			top: 2%;
		}
		@media (min-width: ${sizes.constrains.desktop}px) {
			width: min(1150px, 90vw);
		}
	}
`;

export const FiltersConstrain = styled.section`
	display: grid;
	margin: 0 auto;
	padding: 70px 20px 0;
	place-items: center;
`;

export const FilterComponentConstrain = styled.section`
	padding: 20px;
	margin-inline: 20px;

	@media (min-width: calc(${sizes.media.smallMaxWidth}px + 0.5px)) {
		padding: 40px;
	}
`;

export const ContentWrap = styled.div`
	animation: ${fadeIn} 0.5s forwards;
	background: ${colors.primary.ice};
	border-radius: 5px 5px 0 0;
	height: auto;
	max-height: calc(100% - 105px);
	max-width: ${sizes.constrains.filtersModal}px;
	overflow-x: hidden;
	overflow-y: auto;
	scroll-behavior: smooth;
	width: 100%;
	position: relative;
	pointer-events: all;

	${media.medium`
     height:calc(100% - 90px);
     min-height: calc(100% - 90px);
     height : ${(props) => (props.showcta ? `calc(100% - 90px);` : `calc(100% );`)};
     min-height: ${(props) => (props.showcta ? `calc(100% - 90px);` : `calc(100% );`)};
   `}
`;

/**
 * Now used in individual slides
 * instead of wrapping all components
 * so that Header can be full-width
 * on mobile/small screen sizes
 */

export const Constrain = styled.div`
	animation: ${fadeIn} 0.5s forwards;
	display: flex;
	flex-direction: column;
	max-width: ${sizes.constrains.filtersModalContent + 40}px;
	position: relative;
	width: 100%;
`;

export const FooterWrap = styled.section`
	background-color: ${colors.functional.paleGrey};
	height: 90px;
	position: sticky;
	border-radius: 0px 0px 5px 5px;
	display: grid;
	place-items: center;
	pointer-events: all;
`;

export const ShowResults = styled(Button)`
	width: min(100%, 290px);
	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
    &.rebranding  {
      color: ${colors.primary.ice};
      background-color: ${colors.celebrity.lightOrange} !important;
      border: 1px solid ${colors.celebrity.lightOrange};
    } 
    &.rebranding:hover {
      background-color: ${colors.celebrity.darkOrange} !important;
      border: 1px solid  ${colors.celebrity.darkOrange};
    }   
    `,
		})[theme.brandCode]}
`;

export const Divider = styled.hr`
	background-color: ${colors.functional.middleGray};
	border: 0.5px solid ${colors.functional.middleGray};
	margin: 20px 0;
	width: 100%;
`;

const SectionTitleContent = styled(Typography)`
	color: ${({ palette }) => palette.secondary.main};
	text-transform: capitalize;
	&.sectionTitle {
		margin-bottom: 20px;
		${({ theme }) =>
			({
				[BrandCode.RoyalCaribbean]: `
		font-family: ${theme.typography.fontFamilyBold};
		font-size: 20px;
	`,
				[BrandCode.Celebrity]: `
    font-family: ${theme.typography.fontFamilySemiBold};
    font-size: 18px;
	`,
			})[theme.brandCode]}
	}
	&.portSection {
		font-family: ${fonts.primary.regular};
		font-size: 14px;
		line-height: 16px;
		margin: 20px 0 10px 0;
	}
`;

export function SectionTitle({ className, variant, title }) {
	const { palette } = useTheme();
	const classes = 'sectionTitle'.concat(className ? ` ${className}` : '');

	return (
		<SectionTitleContent variant={variant || 'title5'} palette={palette} className={classes} component="div">
			{title}
		</SectionTitleContent>
	);
}
